import { createActionsHook } from 'src/lib/sweetState';

import { AnnotationStore } from './AnnotationStore';

export const useAnnotationActions = createActionsHook(AnnotationStore);
